export const listingMixin = {
    props: {
        items: {
            type: Array,
            default: () => []
        },
        canShowCourseDetails: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        isCourse (item) {
            return item.itemType === 'course'
        },
        isCollection (item) {
            return item.itemType === 'collection'
        },
        isLearningPath (item) {
            return item.itemType === 'learning_path'
        }
    }
}
